import { FC } from 'react';
import { useAppScopeStore } from '@frontend/scope';
import { CheckboxField, useControlledField, useTooltip } from '@frontend/design-system';

interface LocationCheckboxProps {
  locationId: string;
  isSelected: boolean;
  onChange: (locationId: string) => void;
  trackingId?: string;
}

const TOOLTIP_THRESHOLD_CHAR_LENGTH = 38;

const LocationCheckbox: FC<LocationCheckboxProps> = ({
  isSelected,
  locationId,
  onChange,
  trackingId,
  ...otherProps
}) => {
  const { getScopeName } = useAppScopeStore();
  const { tooltipProps, Tooltip, triggerProps } = useTooltip();
  const locationName = getScopeName(locationId);
  const checkboxProps = useControlledField({
    type: 'checkbox',
    value: isSelected,
    onChange: () => {
      onChange(locationId);
    },
  });

  return (
    <>
      <div {...triggerProps} {...otherProps}>
        <CheckboxField {...checkboxProps} name='location-checkbox' label={locationName} trackingId={trackingId} />
      </div>

      {locationName.length > TOOLTIP_THRESHOLD_CHAR_LENGTH && <Tooltip {...tooltipProps}>{locationName}</Tooltip>}
    </>
  );
};

export default LocationCheckbox;
